import React, { FC } from 'react'
import yup from 'yup'

import Window from '../dialog/Window'
import Wrapper from './Wrapper'

import {
  FormSchema,
  FormHandlers,
} from '../../../types/frontend/form'

interface FormDialogProps {
  schema: FormSchema,
  validationSchema?: yup.ObjectSchema<any>,
  handlers?: FormHandlers,
  initialValues: any,
  error?: string,
  loading?: boolean,
  submitTitle?: string,
  onSubmit: {
    (data: any): void,
  },
  onCancel: {
    (): void,
  },
  [other: string]: any,
}

const FormDialog: FC<React.PropsWithChildren<FormDialogProps>> = ({
  schema,
  validationSchema,
  handlers = {},
  initialValues,
  error,
  loading,
  onSubmit,
  onCancel,
  submitTitle = 'Submit',
  ...windowProps
}) => {
  return (
    <Wrapper
      validationSchema={ validationSchema }
      initialValues={ initialValues }
      handlers={ handlers }
      onSubmit={ onSubmit }
    >
      {
        ({
          render,
          isValid,
          onSubmit,
        }) => {
          return (
            <Window
              open
              loading={ loading }
              disabled={ isValid ? false : true }
              onSubmit={ onSubmit }
              onCancel={ onCancel }
              submitTitle={ submitTitle }
              { ...windowProps }
            >
              { render(schema) }
            </Window>
          )
        }
      }
    </Wrapper>
  )
}

export default FormDialog